import React, { useState, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const PdfViewerModal = ({ pdfFile, onClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [pdfError, setPdfError] = useState(false);
  const [pageWidth, setPageWidth] = useState(null);
  const containerRef = useRef(null);


  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error) => {
    console.error("Error al cargar el documento PDF:", error);
    setPdfError(true);
  };

    useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        // 80% del ancho de pantalla para móviles, 50% para tablets/escritorio
        const width = window.innerWidth < 768 ? 
          window.innerWidth * 0.8 : 
          Math.min(window.innerWidth * 0.5, 800);
        setPageWidth(width);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  if (pdfError) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
        <div className="relative w-[85%] md:w-[35%] p-5 bg-white rounded-lg">
          <button
            onClick={onClose}
            className="absolute text-xl font-bold text-gray-600 top-2 right-2 hover:text-gray-800"
          >
            &times;
          </button>
          <div className="flex items-center justify-center h-64 text-red-500">
            Error al cargar el PDF. Por favor intente nuevamente.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-[85%] md:w-[52%] pt-6 p-1 h-[60%] md:h-[90%]  bg-white rounded-lg">
        {/* Botón de cierre */}
        <button
          onClick={onClose}
          className="absolute top-0 text-sm font-bold text-gray-600 md:text-xl hover:text-gray-800 right-2"
        >
          &times;
        </button>

        <div ref={containerRef} className="h-full overflow-y-auto rounded ">
          <Document
            file={pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={
              <div className="flex items-center justify-center w-full h-64">
                <div className="w-8 h-8 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
              </div>
            }
            error={
              <div className="flex items-center justify-center h-64 text-red">
                Error al cargar el PDF
              </div>
            }
          >

            <div className="flex flex-col items-center justify-center gap-6">
              {Array.from(new Array(numPages), (el, index) => (
                <div 
                  key={`page_${index + 1}`} 
                  id={`page_${index + 1}`}
                  className="relative pb-6"
                >
                  <Page 
                    pageNumber={index + 1} 
                    width={pageWidth}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    
                  />
                  {index < numPages - 1 && (
                    <div className="absolute bottom-0 left-0 right-0 w-[95%] h-px mx-auto bg-gray-300"></div>
                  )}
                </div>
              ))}
            </div>
            </Document>
          </div>
      </div>
    </div>
  );
};

export default PdfViewerModal;
